import { BrowserClient, Hub } from '@sentry/browser';
import type { Event, EventHint } from '@sentry/types';

import { ReleaseVersion } from '../version';

export const scopedLogger = (
  beforeSend?: (event: Event, hint?: EventHint | undefined) => Event | null,
): Hub => {
  const client = new BrowserClient({
    dsn: 'https://05866aa9ddfb4a9cba3b671295dd93a4@sentry.io/1722611',
    environment:
      process.env.NODE_ENV === 'production' ? 'production' : 'development',
    release: `rr-caja@${ReleaseVersion}`,
    beforeSend,
  });

  return new Hub(client);
};
